import { css } from '@emotion/react';
import { color } from '@uniquegood/realworld-studio-design';
import { useInView } from 'react-intersection-observer';

export function LandingAi() {
  const { ref, inView, entry } = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  return (
    <div css={containerStyle} ref={ref} className={`${inView ? 'fade-in' : ''}`}>
      <p css={subTitleStyle}>클릭만으로 콘텐츠 딸-깍!</p>
      <h2 css={titleStyle}>상상을 콘텐츠로 만드는 AI</h2>
      <p css={textStyle}>
        {`리얼월드 스튜디오 AI는 정보 선택만으로\n작가 수준의 스토리와 인터랙티브 콘텐츠를 즉시 만들어줍니다.`}
      </p>
      <div css={videoContainerStyle}>
        <video src="assets/landing/ai-intro.mp4" autoPlay loop muted />
      </div>
    </div>
  );
}

const containerStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin: 120px 32px;
  opacity: 0;

  &.fade-in {
    animation: fadeInAnimation 1s ease-in forwards;
  }
`;

const titleStyle = css`
  color: ${color.text_default};
  text-align: center;
  font-family: Pretendard;
  font-size: 42px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  @media (max-width: 960px) {
    font-size: 32px;
  }

  @media (max-width: 600px) {
    font-size: 32px;
  }

  @media (max-width: 320px) {
    font-size: 22px;
  }
`;

const subTitleStyle = css`
  color: ${color.palette_primary_purple_100};
  text-align: center;
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  @media (max-width: 960px) {
    font-size: 20px;
  }

  @media (max-width: 600px) {
    font-size: 20px;
  }

  @media (max-width: 320px) {
    font-size: 18px;
  }
`;

const textStyle = css`
  color: ${color.text_subdued};
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: pre-line;

  @media (max-width: 960px) {
    font-size: 14px;
  }

  @media (max-width: 600px) {
    font-size: 14px;
  }

  @media (max-width: 320px) {
    font-size: 12px;
  }
`;

const videoContainerStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  max-height: 576px;
  margin-top: 37px;
  aspect-ratio: 127/95;

  border-radius: 16px;
  overflow: hidden;

  video {
    width: calc(100% + 4px);
    height: calc(100% + 4px);
  }
`;
